import {Banner} from '@wandb/components';
import React from 'react';

import {getErrorMessage} from './LogViewerError';

export type OnRetryFetchMore = () => void;

export interface LogViewerFetchMoreErrorProps {
  error: Error | string;
  isRetrying: boolean;
  onRetry?: OnRetryFetchMore;
}

/**
 * LogViewerFetchMoreError is a compact error banner for 'LogViewer' errors
 * encountered when fetching an additional page of logs.
 */
export const LogViewerFetchMoreError: React.FC<
  LogViewerFetchMoreErrorProps
> = ({error, isRetrying, onRetry}) => {
  return (
    <div
      className="flex justify-center justify-items-center w-full p-16"
      data-testid="log-viewer-fetch-more-error">
      <Banner
        aria-label="Failed to fetch more logs"
        isDismissible={false}
        isVisible={!!error}
        size="md"
        variant="error">
        <Banner.Body>
          <p className="text-ellipsis">
            <strong>Failed to fetch more logs.</strong> {getErrorMessage(error)}
          </p>
        </Banner.Body>
        {onRetry && (
          <Banner.Action
            aria-label="Retry attempt to fetch more logs"
            onPress={onRetry}
            isPending={isRetrying}
            isPendingAriaLabel="Retrying attempt to fetch more logs">
            Retry
          </Banner.Action>
        )}
      </Banner>
    </div>
  );
};
